export default __webpack_public_path__ + "static/screeny-150-gpz-unica-2-81fc260d032482e8c2b17f1915456f10.jpg";